import React from 'react';

import Box from '@material-ui/core/Box';

import type { User } from '@cobliteam/common-types/src/user';

import { HintPopup } from '@cobliteam/base-components';
import { Checkbox } from '@cobliteam/base-components/src/SelectionControls/Checkbox';

interface UserItemProps {
  checked: boolean;
  user: User;
  unselectableMessage?: string;
  onChange: () => void;
}

const UserItem = ({
  checked,
  onChange,
  user,
  unselectableMessage = '',
}: UserItemProps) => {
  const { id, name } = user;

  return (
    <HintPopup
      title={unselectableMessage}
      placement='bottom-start'
      enabled={Boolean(unselectableMessage)}
      arrow
    >
      <Box marginLeft='20px'>
        <Checkbox
          disabled={Boolean(unselectableMessage)}
          key={`${id}-${checked}`}
          checked={checked}
          onChange={onChange}
          label={name}
        />
      </Box>
    </HintPopup>
  );
};
export default UserItem;
